module.exports = __webpack_public_path__ + "static/media/leadership.4bffaba8.svg";